import React from "react";
import { useParams } from "react-router-dom";
import { ShareReferralCard } from "../../../components/organism/SharedReferralCard/SharedReferralCard";
import { GeneralLayout } from "../../../components/layout/GeneralLayout/GeneralLayout";

export const SuccessPage: React.FC = () => {
  // Usamos useParams para obtener los parámetros de la URL, como :userId
  const { userId } = useParams<{ userId: string }>();

  if (!userId) {
    // Opcional: Manejar el caso en que no se proporcione un ID.
    // Podrías redirigir a la página de inicio o mostrar un error.
    return <div>ID de usuario no encontrado.</div>;
  }

  return (
    <GeneralLayout>
      {userId && <ShareReferralCard userId={userId} />}
    </GeneralLayout>
  );
};
